import { SubmitEvent } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { RecoveryCodes } from "components/Navbar/Controls/Settings/SecurityAndAccount/Security/TwoFactorAuthentication/components/RecoveryCodes";

import { SaveRecoveryCodesProps } from "../types";

const SaveRecoveryCodes = ({
    codes,
    isDisabled,
    onCheck,
    closeScreen
}: SaveRecoveryCodesProps) => {
    const { t } = useTranslation();

    const handleSubmit = (e: SubmitEvent<HTMLFormElement>) => {
        e.preventDefault();
        closeScreen();
    };

    return (
        <form onSubmit={handleSubmit}>
            <RecoveryCodes codes={codes} onCheck={onCheck} />

            <Button
                fullWidth
                type="submit"
                variant={BUTTON_VARIANTS.TextOnly}
                color={BUTTON_COLORS.Primary}
                size={BUTTON_SIZES.Normal}
                disabled={isDisabled}
                css={css({
                    marginTop: "24px"
                })}
            >
                {t("Button##finish")}
            </Button>
        </form>
    );
};

export { SaveRecoveryCodes };
